angular.module('picmonicng').controller('CharactersController', [
  '$scope',
  'FactGroupsResource',
  '$modal',
  '$filter',
  'UserService',
  'Picmonics',
  '$location',
  '$stateParams',
  'SearchHistoryResource',
  function (
    $scope,
    FactGroupsResource,
    $modal,
    $filter,
    UserService,
    Picmonics,
    $location,
    $stateParams,
    SearchHistoryResource
  ) {
    $scope.facts = [];

    // Search
    $scope.search = {
      page: 1,
      per_page: 40,
      order: 'fact_count',
    };

    $scope.letters = [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ];

    $scope.search.query = $stateParams.query;

    $scope.back = function () {
      $window.history.back();
    };

    $scope.previousPage = function () {
      if (!$scope.loading) {
        $scope.search.page--;
        $scope.doSearch();
      }
    };

    $scope.nextPage = function () {
      if (!$scope.loading) {
        $scope.search.page++;
        $scope.doSearch();
      }
    };

    $scope.showModal = function (fact) {
      $modal.open({
        templateUrl: '/templates/modals/fact-group.html',
        size: 'lg',
        backdropClass: 'less-backdrop',
        controller: [
          '$scope',
          'FactGroupsResource',
          'hotkeys',
          function ($scope, FactGroupsResource, hotkeys) {
            $scope.picmonic = null;
            $scope.showThumbnail = false;
            $scope.childPicmonic = null;
            $scope.childFact = null;

            $scope.fact = fact;
            $scope.fact.facts_loading = true;
            $scope.fact.facts = FactGroupsResource.query({
              fact_group_id: fact.fact_group_id,
              resource: 'facts',
            });

            $scope.fact.facts.$promise.finally(function () {
              $scope.fact.facts_loading = false;
            });

            $scope.selectFact = function (fact, $index, updatePicmonic) {
              angular.forEach($scope.fact.facts, function (value, key) {
                value.selected = false;
              });
              angular.forEach($scope.fact.children, function (value, key) {
                value.selected = false;
              });

              $('.facts .sidescroll-wrapper:eq( 0 )').animate(
                {
                  scrollLeft: $('.picmonic-tile:eq(0)').outerWidth(true) * $index - 15,
                },
                'slow'
              );
              $('.facts .character-list:eq( 0 )').animate(
                { scrollTop: $('li:eq(0)').outerHeight(true) * $index - 15 },
                'slow'
              );

              if ($scope.picmonic || updatePicmonic) {
                $scope.picmonic = fact.card;
              }

              fact.selected = true;
            };

            $scope.selectChild = function (fact, $index) {
              angular.forEach($scope.fact.facts, function (value, key) {
                value.selected = false;
              });
              angular.forEach($scope.fact.children, function (value, key) {
                value.selected = false;
              });

              $('.children .sidescroll-wrapper:eq( 0 )').animate({ scrollLeft: 225 * $index - 15 }, 'slow');
              $('.children .character-list:eq( 0 )').animate(
                { scrollTop: $('li:eq(0)').outerHeight(true) * $index - 15 },
                'slow'
              );
              $('.modal:eq(0)').animate({ scrollTop: '+=350px' }, 'slow');

              fact.selected = true;
              $scope.childPicmonic = null;
            };

            $scope.openPicmonic = function (slug) {
              window.open('/learn/' + slug);
            };

            $scope.toggleThumbnail = function () {
              $scope.showThumbnail = !$scope.showThumbnail;
            };

            $scope.hidePicmonic = function (picmonic) {
              $scope.picmonic = null;
            };

            $scope.showChildPicmonic = function (picmonic) {
              $scope.childPicmonic = picmonic;
            };

            $scope.hideChildPicmonic = function (picmonic) {
              $scope.childPicmonic = null;
            };

            $scope.showRelated = function (childfact) {
              $scope.childFact = childfact;
              $scope.childFact.facts = FactGroupsResource.query({
                fact_group_id: $scope.childFact.fact_group_id,
                resource: 'facts',
              });
            };

            hotkeys
              .bindTo($scope)
              .add({
                combo: ['down'],
                callback: function (e) {
                  e.preventDefault();

                  var facts = $filter('orderBy')($scope.fact.facts, ['card.name']);
                  var selected = $filter('findInArray')(facts, true, 'selected');
                  if (selected) {
                    var currentPos = facts.indexOf(selected);

                    if (currentPos < facts.length - 1) {
                      $scope.selectFact(facts[currentPos + 1], currentPos + 1);
                    } else {
                      $scope.selectFact(facts[0], 0);
                    }
                  } else {
                    var children = $filter('orderBy')($scope.fact.children, ['name']);
                    selected = $filter('findInArray')(children, true, 'selected');
                    if (selected) {
                      currentPos = children.indexOf(selected);

                      if (currentPos < children.length - 1) {
                        $scope.selectChild(children[currentPos + 1]);
                      } else {
                        $scope.selectChild(children[0]);
                      }
                    }
                  }
                },
              })
              .add({
                combo: ['up'],
                callback: function (e) {
                  e.preventDefault();

                  var facts = $filter('orderBy')($scope.fact.facts, ['card.name']);
                  var selected = $filter('findInArray')(facts, true, 'selected');
                  if (selected) {
                    var currentPos = facts.indexOf(selected);

                    if (currentPos === 0) {
                      $scope.selectFact(facts[facts.length - 1], facts.length - 1);
                    } else {
                      $scope.selectFact(facts[currentPos - 1], currentPos - 1);
                    }
                  } else {
                    var children = $filter('orderBy')($scope.fact.children, ['name']);
                    selected = $filter('findInArray')(children, true, 'selected');
                    if (selected) {
                      currentPos = children.indexOf(selected);

                      if (currentPos === 0) {
                        $scope.selectChild(children[children.length - 1]);
                      } else {
                        $scope.selectChild(children[currentPos - 1]);
                      }
                    }
                  }
                },
              });
          },
        ],
      });
    };

    $scope.showRelated = function (fact) {
      if (fact.show_related) {
        fact.show_related = !fact.show_related;
      } else {
        fact.show_related = true;
        fact.facts_loading = true;
        fact.facts = FactGroupsResource.query({
          fact_group_id: fact.fact_group_id,
          resource: 'facts',
        });

        fact.facts.$promise.finally(function () {
          fact.facts_loading = false;
        });
      }
    };

    $scope.doNewSearch = function () {
      $scope.search.page = 1;
      $location.search('query', $scope.search.query);
      if ($scope.search.query) {
        SearchHistoryResource.save({
          search_origin: 'glossary',
          search_term: $scope.search.query,
        });
      }
    };

    $scope.doSearch = function () {
      $scope.loading = true;
      $scope.facts = FactGroupsResource.get($scope.search);

      $scope.facts.$promise.then(function (data) {
        $scope.loading = false;
        $scope.$emit('endInteraction');
      });
    };

    $scope.selectLetter = function (letter) {
      $scope.search.page = 1;
      $scope.search.letter = letter;
      $scope.search.query = null;
      $scope.doSearch();
    };

    $scope.doSearch();
  },
]);
